import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectDealerAndVehicleData,
  setAudiCodeVehicle,
  setCarlineVehicle,
  setVehicle,
} from '../redux/dealerAndVehicleReducer';
import { selectAppConfig } from '../redux/appConfigReducer';
import useFetchByCarline from './fetchHooks/useFetchByCarline';
import useFetchByAudiCode from './fetchHooks/useFetchByAudiCode';
import useFetchByVin from './fetchHooks/useFetchByVin';

const useVehicleInfo = () => {
  const dispatch = useDispatch();

  const { vehicleId, vehicleType, market, carline, audiCode } = useSelector(selectAppConfig);

  const { vehicleData, loading } = useFetchByVin(vehicleId, market, vehicleType);
  const { vehicleCarlineDetails, isCarlineVehicleLoading } = useFetchByCarline(carline, market);
  const { vehicleAudiCodeDetails, isAudiCodeVehicleLoading } = useFetchByAudiCode(audiCode);

  const isVehicleLoading = loading || isCarlineVehicleLoading || isAudiCodeVehicleLoading;

  useEffect(() => {
    if (vehicleCarlineDetails) {
      dispatch(setCarlineVehicle(vehicleCarlineDetails));
      return;
    }
    if (vehicleAudiCodeDetails) {
      dispatch(setAudiCodeVehicle(vehicleAudiCodeDetails));
      return;
    }
    if (vehicleData) {
      dispatch(setVehicle(vehicleData));
    }
  }, [dispatch, vehicleAudiCodeDetails, vehicleCarlineDetails, vehicleData]);

  const { vehicle } = useSelector(selectDealerAndVehicleData);

  return { vehicle, isVehicleLoading };
};

export default useVehicleInfo;
